<template>
  <ApolloMutation
    :mutation="
      (gql) => gql`mutation AddStoryToLibrary($storyId: String!) {
        addLibraryStoryUser(input: {storyId: $storyId}) {
          user {
            id
            libraryStories(first: 1000) {# TODO SC-1303 - https://story-city.atlassian.net/browse/SC-1303 - we shouldn't need to get their entire library but this updates the cache and for some reason the cache function commented out below doesn't work
              edges {
                node {
                  id
                }
              }
            }
          }
        }
      }`"
    :variables="{ storyId: idWithIri }"
    @done="$emit('added')"
    :update="updateCache"
  >
    <template v-slot="{ mutate, loading }">
      <v-btn :loading="loading" @click="mutate">{{ $t('store.addToLibrary') }} </v-btn>
    </template>
  </ApolloMutation>
</template>
<script>
import gql from 'graphql-tag'
const fragments = {
  story: gql`
    fragment story on Story {
      id
    }
  `
}
export default {
  props: {
    idWithIri: String,
  },
  methods: {
    updateCache (store) {
      const query = {
        query: gql`
        query {
          getLoggedInUser {
            id
            libraryStories(first: 1000) { # TODO - pagination handling https://story-city.atlassian.net/browse/SC-1092
              edges {
                node {
                  ...story
                }
              }
            }
          }
        }
        ${fragments.story}
        `,
        variables: {
          threadId: this.threadId,
        },
      }
      // Read the query from cache
      const data = store.readQuery(query)
      // Mutate cache result
      const newData = data.getLoggedInUser.libraryStories.edges.concat({ __typename: 'StoryEdge', node: { id: this.idWithIri, __typename: 'Story'}});
      const formattedNewData = {
        getLoggedInUser: {
          id: data.getLoggedInUser.id,
          libraryStories: {
            __typename: "StoryConnection",
            edges: newData,
          },
          __typename: "User",
        },
      }

      // Write back to the cache
      store.writeQuery({
        ...query,
        formattedNewData
      })
    },
  }
}
</script>